import React, { useState } from "react";
import { useDispatch } from "react-redux";

import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { makeStyles } from "@material-ui/core/styles";

import pageTitle from "../../utils/pageTitle";
import TextSearch from "../../components/search/TextSearch";
import {
    GOOGLE_PLACE_AUTOCOMPLETE_URL,
    GOOGLE_PLACE_ID_FINDER_URL
} from "../../config";
import { showErrorAlert } from "../../store/actions/alerts";

import makeApiRequest from "../../utils/axios/new-axios";

const useStyles = makeStyles((theme) => ({
    paperTable: {
        width: "100%",
        overflowX: "auto",
        marginTop: theme.spacing(2),
        padding: "15px"
    },
}));


function PlaceIdFinder() {
    pageTitle("Google Place ID Finder");
    const dispatch = useDispatch();
    const classes = useStyles();

    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState(null);


    async function callGoogleAutoCompleteApi(searchText) {
        if (searchText && searchText.trim().length > 0) {
            setIsLoading(true);
            setResult(null);
            await makeApiRequest({
                url: `${GOOGLE_PLACE_AUTOCOMPLETE_URL.url}`,
                method: GOOGLE_PLACE_AUTOCOMPLETE_URL.method,
                params: {
                    input: searchText
                },
            })
                .then((response) => {
                    //console.log(response.data);
                    if (response.data.status === "OK" && response.data.predictions) {
                        if (response.data.predictions.length > 0) {
                            setResult(response.data.predictions)
                        } else {
                            dispatch(showErrorAlert("No results found"));
                        }
                    } else {
                        dispatch(
                            showErrorAlert(
                                `Google API Error : ${response.data.status}` +
                                (!!response.data.error_message &&
                                    ` - ${response.data.error_message}`)
                            )
                        );
                    }
                })
                .catch((error) => {
                    dispatch(
                        showErrorAlert(
                            "Error Google AutoComplete API : " +
                            (!!error.response
                                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                                : error.message)
                        )
                    );
                });

            setIsLoading(false);
        }
    }

    return (
        <Container style={{ padding: "10px" }}>
            <h1 style={{ color: "red", backgroundColor: "yellow", textAlign: "center" }}>
                Use this page ONLY IF (
                <Link
                    color="inherit"
                    target="_blank"
                    href={GOOGLE_PLACE_ID_FINDER_URL}
                >
                    Google Place ID Finder
                </Link>
                ) Link FAILS!!
            </h1>

            <TextSearch
                label="Search Location (Full name)"
                handleSearch={callGoogleAutoCompleteApi}
                isSubmitting={isLoading}
            />

            {!!result && result.length > 0 && (
                <Paper className={classes.paperTable}>
                    <Table size="small" style={{ tableLayout: "fixed" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: "50%" }}>Description</TableCell>
                                <TableCell>Place ID</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {result.map((r, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell style={{ width: "50%" }}>{r.description}</TableCell>
                                        <TableCell>{r.place_id}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            )}
        </Container>
    )
}

export default PlaceIdFinder
